import { __assign as o } from "./_virtual/_tslib.js";
import { forwardRef as t, useMemo as n, useImperativeHandle as e, useEffect as r } from "react";
import i from "./utils/clone.js";
import { useBindProp as s } from "./hooks/props.js";
import { getInitialOptionsFromProps as f } from "./utils/options.js";
import c from "./hooks/component.js";
import { createPortal as m } from "react-dom";
import u from "./hooks/common/point.js";
var a = t(function (t, a) {
  var p = n(function () {
    return document.createElement("div");
  }, []),
      d = c({
    init: function init(n) {
      var e = t.position,
          r = o(o({}, f(t)), {
        position: i(e)
      });
      return r.icon && (r.icon = l(r.icon)), new n.Marker(r);
    },
    destroy: function destroy(o) {
      o && "function" == typeof o.stopMove && o.stopMove();
    }
  }, t);
  return e(a, function () {
    return d;
  }, [d]), r(function () {
    p.className = t.className || "";
  }, [t.className]), r(function () {
    p.style.cssText = "", Object.assign(p.style, t.style);
  }, [t.style]), u(d, t), s(d, {
    setter: function setter(o, t) {
      if (t) {
        var n = l(t);
        o.setIcon(n);
      }
    }
  }, t.icon), s(d, {
    setter: function setter(t, n) {
      n && t.setLabel(function (t) {
        if (!t) return;
        var n = o({}, t);
        Array.isArray(n.offset) && (n.offset = new window.AMap.Pixel(n.offset[0], n.offset[1]));
        return n;
      }(n));
    }
  }, t.label), t.children ? (d && d.setContent(p), m(t.children, p)) : null;
});

function l(o) {
  return "string" == typeof o ? o : new window.AMap.Icon(o);
}

export default a;